/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';

let configToken = axios.create();

/* default response*/
configToken.interceptors.response.use(
    (response) => {
        return Promise.resolve(response);
    },
    async (error) => {
        return Promise.reject(error?.response || error);
    }
);

/* default request */
configToken.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default {
    get: configToken.get,
    post: configToken.post,
    put: configToken.put,
    delete: configToken.delete,
    patch: configToken.patch,
};
